<template>
    <div class="filter-page" >
      <!--  salesorder form component -->
      <FilterForm
        :module="$route.params.title"
        :submitted="submitted"
        :code="code"
        v-on:filterform="filterform($event)"
      ></FilterForm>
    </div>
</template>
<script>
import FilterForm from "@/components/Form/CustomFilter"; // SalesOrder form for create and update
import store from "@/store/index";
import { mapState } from "vuex";
import RecordNotFound from "@/pages/Error/RecordNotFound";
export default {
  name: "FilterCreate",
  components: {
    FilterForm,
    RecordNotFound
  },
  data() {
    return {
      submitted: false,
      code: 200,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    filterform(data) {
      var path =
        this.$route.name == "FilterUpdate"
          ? "filterupdateList"
          : "filtercreateList";

      var _data =
        this.$route.name == "FilterUpdate"
          ? { id: data.id, data: data.items }
          : data.items;
      // var message = !data.id ? "created" : "updated";
      this.submitted = true;
      this.$store
        .dispatch(data.module + "/" + path, _data)
        .then(() => {
          this.code = this.$store.state[data.module].code;
          if (this.$store.state[data.module].code == 200) {
            //  show if invoice successfully created
            // message = "New Filter has been " + message + " successfully!";
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.$store.state[data.module].status_message,
              type: this.$store.state[data.module].status_type,
              showCloseButton: true
            });
            this.$router.push({
              name:
                this.$route.params.path != "Index"
                  ? this.$route.params.path
                  : store.state.general.allfilter_details[
                      this.$route.params.route
                    ].path,
              query: {
                status: this.$store.state[data.module].updated_id
              }
            });
          } else {
            this.submitted = false;
            //  showing eror message
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.$store.state[data.module].status_message,
              type: this.$store.state[data.module].status_type,
              showCloseButton: true
            });
          }
        })
        .catch(() => {});
    }
  },
  beforeRouteEnter(to, from, next) {
    to.params.path = from.name;
    store.state.settings.status_code="";
    store
      .dispatch(
        (to.params.module ||
          store.state.general.allfilter_details[to.params.route].module) +
          "/" +
          (to.params.call ||
            store.state.general.allfilter_details[to.params.route].details),
        JSON.stringify({
          type: to.params.type || "",
          page: "filterdetails"
        })
      )
      .then(() => {
        next();
      });
  },
  created() {
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      status_code: state => state.settings.status_code,
      status_message: state => state.settings.status_message,
      status_type: state => state.settings.status_type
    })
  }
};
</script>